export const randomNumber = function () {
  return function(string, max) {
    return _.random(max || 999);
  };
};
